import React from 'react';
import { View, Text } from 'react-native';
import ColorWrapper from '@styles/colors';
import { ColorFunction } from '@styles/colors/types';
import { font as initialFont } from '@styles/fonts';
import { scale as initialScale } from '@components/frame';
import { ParsedMachineEventData } from '@v2/pages/common/components/NCFileBatchEvents/types';
import { useManageRawMachineEventDataDisplay } from '@v2/pages/common/components/NCFileBatchEvents/components/TraceEventPopup/hooks/useManageRawMachineEventDataDisplay';
import { NCFileBatchEventsProps } from '@v2/pages/common/components/NCFileBatchEvents';

export interface RawMachineEventDataDisplayProps extends Pick<NCFileBatchEventsProps, 'scale' | 'font'> {
  data: ParsedMachineEventData | null;
}

interface RawMachineEventDataDisplayComponentProps extends RawMachineEventDataDisplayProps {
  C: ColorFunction;
}

const RawMachineEventDataDisplayComponent: React.FC<RawMachineEventDataDisplayComponentProps> = ({
  data,
  scale = initialScale,
  font = initialFont,
  C,
}) => {
  const { formattedData, renderItem } = useManageRawMachineEventDataDisplay({
    data,
    scale,
    font,
    C,
  });

  if (!data) {
    return (
      <View>
        <Text style={[font.Body, { color: C('Content/Light/Tertiary') }]}>No data available</Text>
      </View>
    );
  }

  return <View style={{ backgroundColor: C('Background/Light/Secondary') }}>{formattedData.map((item, index) => renderItem(item, index))}</View>;
};

export const RawMachineEventDataDisplay = ColorWrapper(RawMachineEventDataDisplayComponent);
